import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import cn from "classnames";
import store from "store";

import routing from "../../../routing";
import Icon from "../../../icon";
import { setItem, hasItem } from "../../../cookie";
import { battleOfTheHunsId, christmasId, getPlayItems } from "../../../../common/parameters";
import getName, { getNameLang } from "../../../../common/helpers/getName";

import PackName from "../../../components/PackName";
import Breadcrumb from "../../../components/Breadcrumb";
import Tooltip from "../../../components/Tooltip";
import TutorialButton from "../../../components/Tutorial/Button";
import ViewSharedLabel from "../../../components/ViewSharedLabel";
import { AttentionMarker, AttentionArrow } from "../../../components/Attention";
import AdSense from "../../../components/AdSense";
import ContextMenu from "../../../components/ContextMenu";

import PlanTutorial from "./PlanTutorial";

import {
    StyledUpperRow,
    LeftTop,
    RightTop,
    UpperBtn,
    Alert,
    Center,
    BelowBreadcrumbAdSense,
    CovidHint,
} from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";
import FormattedHtmlMessage from "../../../../common/helpers/FormattedHtmlMessage";

class UpperRow extends Component<IProps, IState> {
    state: IState = {
        showPlayAttention: false,
        showBrowseAttention: false,
        openContext: null,
    };
    browseAttentionTimer?: ReturnType<typeof setTimeout>
    componentDidMount() {
        if (!hasItem("planSolveAttention")) {
            this.setState({ showPlayAttention: true });
        }
    }
    componentWillUnmount() {
        clearTimeout(this.browseAttentionTimer);
        window.removeEventListener("click", this.closeOpenContext)
    }
    componentDidUpdate(prev: IProps) {
        if (!prev.plan.metaDone && this.props.plan.metaDone) {
            this.browseAttentionTimer = setTimeout(() => {
                this.setState({ showBrowseAttention: true });
                this.browseAttentionTimer = setTimeout(() => {
                    this.setState({ showBrowseAttention: false });
                }, 6000);
            }, 4500);
        }
    }
    closeOpenContext = () => {
        this.setState({ openContext: null });
        window.removeEventListener("click", this.closeOpenContext)
    }
    setOpenContext = (openContext: "play") => {
        if (this.state.openContext === openContext) return;
        this.setState({ openContext });
        setTimeout(() => {
            window.addEventListener("click", this.closeOpenContext);
        });
    }
    render() {
        const {
            plan,
            publicView,
            notLoggedIn,
            showTutorial,
            toggleTutorial,
            simulation,
            user,
            isCovid,
            moderatorView,
        } = this.props;
        const { showPlayAttention, showBrowseAttention, openContext } = this.state;
        const isExtra = plan._id === battleOfTheHunsId || plan._id === christmasId;
        const isChristmas = plan._id === christmasId;
        const name = !isCovid ? getName(plan.name, { locale: user.language }) : undefined;
        const lang = name ? getNameLang(plan.name, name) : undefined;
        return (
            <StyledUpperRow isCovid={isCovid}>
                <LeftTop>
                    {!isCovid &&
                        (!publicView ? (
                            <Breadcrumb
                                pack={<PackName pack={{ name: plan.packName! }} />}
                                plan={name!}
                                packId={plan.pack}
                                lang={lang!}
                            />
                        ) : (
                            <Breadcrumb browse plan={name} moderatorView={moderatorView} lang={lang!} />
                        ))}
                    {isCovid && (
                        <CovidHint>
                            <FormattedMessage {...messages.covidUse} /> <Icon i="arrowback" />
                        </CovidHint>
                    )}
                </LeftTop>
                <RightTop isCovid={isCovid}>
                    {!isCovid && (
                        <UpperBtn className={cn(publicView)} onMouseLeave={this.closeOpenContext}>
                            {showPlayAttention && (
                                <AttentionMarker>
                                    <FormattedMessage {...messages.attention} />
                                    <AttentionArrow />
                                </AttentionMarker>
                            )}
                            <Tooltip
                                label={<FormattedMessage {...messages.playTest} />}
                                disabled={(!publicView && !plan.playable) || !!openContext}
                            >
                                <Link
                                    to={
                                        "/" +
                                        (isChristmas
                                            ? routing.christmasEdition
                                            : isExtra
                                            ? routing.battleOfTheHuns
                                            : (publicView ? routing.publicPlay : routing.play) + "/" + plan._id)
                                    }
                                    className={cn(!plan.playable && !publicView && "QuickButtonDisabled")}
                                    onClick={e => {
                                        if (simulation) {
                                            e.preventDefault();
                                        } else {
                                            setItem("planSolveAttention", true, 60 * 60 * 24 * 365);
                                            if (plan.experience.enabled) {
                                                this.setOpenContext("play");
                                                e.preventDefault();
                                            } else {
                                                store.set("play-plan-id", plan._id);
                                            }
                                        }
                                    }}
                                >
                                    <Icon i="playlarge" />
                                </Link>
                            </Tooltip>
                            {openContext === "play" && (
                                <ContextMenu
                                    getItems={getPlayItems}
                                    top={40}
                                    mobileBottom={50}
                                    planId={plan._id}
                                    publicView={publicView}
                                    mobileAlign="left"
                                    backgroundColor="white"
                                />
                            )}
                        </UpperBtn>
                    )}
                    {!isExtra && (
                        <UpperBtn>
                            <Tooltip
                                label={
                                    notLoggedIn ? (
                                        <FormattedMessage {...messages.logInToGadgets} />
                                    ) : plan.shared || publicView ? (
                                        plan.modified! < plan.published! || publicView ? (
                                            user.profiled ? (
                                                <FormattedMessage {...messages.playShareTest} />
                                            ) : (
                                                <FormattedMessage {...messages.profileToGadgets} />
                                            )
                                        ) : (
                                            <Center>
                                                <FormattedMessage {...messages.playShareTest} />
                                                <br />
                                                <FormattedHtmlMessage {...messages.modifiedRefresh} />
                                            </Center>
                                        )
                                    ) : (
                                        <Center>
                                            <FormattedMessage {...messages.playShareTest} />
                                            <br />
                                            <FormattedHtmlMessage {...messages.metaFirst} />
                                        </Center>
                                    )
                                }
                                disabled={!publicView && !plan.playable}
                                marginTop={8}
                                grey={notLoggedIn || (!publicView && !plan.shared) || (!publicView && !plan.playable)}
                            >
                                {!notLoggedIn && (plan.shared || publicView) ? (
                                    <Link
                                        to={
                                            user.profiled
                                                ? "/" + routing.share + "/" + (publicView ? plan._id : plan.publicId)
                                                : "/" + routing.signupProfile
                                        }
                                        className={cn(
                                            (notLoggedIn || (!publicView && !plan.playable)) && "QuickButtonDisabled"
                                        )}
                                        onClick={e => {
                                            if (simulation) {
                                                e.preventDefault();
                                            }
                                        }}
                                    >
                                        <Icon i="whiteboard" style={{ marginTop: 2 }} />
                                        {plan.modified! >= plan.published! && <Alert>!</Alert>}
                                    </Link>
                                ) : (
                                    <div className={cn("QuickButtonDisabled")}>
                                        <Icon i="whiteboard" style={{ marginTop: 2 }} />
                                    </div>
                                )}
                            </Tooltip>
                        </UpperBtn>
                    )}
                    {!isCovid && plan.shared && !publicView && (
                        <UpperBtn>
                            {showBrowseAttention && (
                                <AttentionMarker isBrowse>
                                    <FormattedMessage {...messages.sharableAttention} />
                                    <AttentionArrow isBrowse />
                                </AttentionMarker>
                            )}
                            <Tooltip label={<ViewSharedLabel plan={plan} />}>
                                <Link
                                    to={"/" + routing.publicPlan + "/" + plan.publicId}
                                    className={cn("Active ListedPlan")}
                                    onClick={e => simulation && e.preventDefault()}
                                >
                                    <Icon i="browse" />
                                </Link>
                            </Tooltip>
                        </UpperBtn>
                    )}
                    {!isCovid && publicView && user.loggedIn && (user.permission >= 2 || user._id === plan.user) && (
                        <UpperBtn>
                            <Tooltip label={<FormattedHtmlMessage {...messages.originalPlan} />}>
                                <Link
                                    to={"/" + routing.plan + "/" + plan.originalId}
                                    className={cn("Active OriginalPlan")}
                                    onClick={e => simulation && e.preventDefault()}
                                >
                                    <Icon i="dashboard" />
                                </Link>
                            </Tooltip>
                        </UpperBtn>
                    )}
                    {!simulation && <TutorialButton onClick={() => toggleTutorial(true)} />}
                    {showTutorial && <PlanTutorial close={() => toggleTutorial(false)} />}
                </RightTop>
                {!isCovid && publicView && !moderatorView && (
                    <BelowBreadcrumbAdSense>
                        <AdSense slot="PublicTest_BelowBreadcrumb-Mobile" width={320} height={100} />
                    </BelowBreadcrumbAdSense>
                )}
            </StyledUpperRow>
        );
    }
}

export default UpperRow;
